<template>
  <div class="position-relative fill-width">
    <div class="pa-8 position-relative overflow-hidden d-flex">
      <div>
        <div class="text-title font-weight-bold">{{ customer.personal.full_name }}</div>
        <div class="text-small mt-2 blue-grey--text text--darken-1">{{ customer.personal.phone }}</div>
        <div class="text-small mt-1">{{ customer.personal.address }}</div>
      </div>
      <div class="ml-auto text-right">
        <div class="text-title font-weight-bold">Invoice</div>
        <div class="text-title font-weight-bold mt-1 grey--text text--darken-1">
          {{request.cred_plus_upfront | currency }}
        </div>
      </div>

      <v-icon class="bg-cart" size="100">mdi-cart</v-icon>
    </div>

    <p class="py-8 px-6" v-if="!request.items.length">
      <v-icon class="mr-2" size="18">mdi-alert-circle-outline</v-icon>
      Items will be added by merchant
    </p>
    <div class="px-5 pb-10" v-else>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">S/N</th>
            <th class="text-left">Product</th>
            <th class="text-left">Qty</th>
            <th class="text-right">Total</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="item.id" v-for="(item, i) in request.items">
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.item_plan.quantity }}</td>
            <td class="text-right">{{ (+item.price * +item.item_plan.quantity) | currency }}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>Total</td>
            <td>{{ total | currency }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <template v-if="!request.offer && onCredit">
      <v-divider style="border-color: rgba(206,25,25,0.2)"/>
      <div class="red lighten-5 py-1 text-small text-center red--text">Estimated offer</div>
      <v-divider style="border-color: rgba(206,25,25,0.2)"/>
    </template>
    <div class="text-center d-flex flex-column" style="background: #fefefe" v-if="onCredit">
      <v-divider v-if="request.offer"/>
      <v-row class="py-8">
        <v-col>
          <div class="text-title font-weight-bold">
            {{ $store.getters['request/upfrontAmount'] | currency }}
          </div>
          <small class="mt-1">
            Upfront
            <v-chip class="teal--text ml-1" color="teal lighten-5" dark v-if="request.upfront_paid === 1" x-small>
              Paid
            </v-chip>
            <v-chip class="red--text ml-1" color="red lighten-5" dark v-if="request.upfront_paid === 0" x-small>
              Not paid
            </v-chip>
          </small>
        </v-col>
        <v-col>
          <div class="text-title font-weight-bold">
            {{ $store.getters['request/monthlyAmount'] | currency }}
          </div>
          <small class="mt-1">Monthly amount</small>
        </v-col>
        <v-col>
          <div class="text-title font-weight-bold">
            {{ $store.getters['request/noOfMonths'] }} month(s)
          </div>
          <small class="mt-1">Duration</small>
        </v-col>
      </v-row>
    </div>
    <v-divider/>
  </div>
</template>

<script>
export default {
  name: "RequestInvoiceDesktop",
  data() {
    return {
      request: this.$store.state.request,
      customer: this.$store.state.customer,
      merchant: this.$store.state.merchant,
    }
  },
  computed: {
    onCredit() {
      return this.$store.getters['request/credit'];
    },
    status() {
      return this.$store.state.request.req_status
    },
    total() {
      return this.request.items.reduce((acc, item) => {
        acc += (item.price * item.item_plan.quantity);
        return acc;
      }, 0)
    },
    amountToPay() {
      return this.$store.getters["request/amountToPay"]
    },
  }
}
</script>

<style lang="scss">
.bg-cart {
  position: absolute !important;
  bottom: -30px;
  left: calc(100% - 60px);
  transform: rotate(5deg);
  opacity: .1;
}
</style>
